import React, { Fragment, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const SSN = props => {
    const {
        inputData: {
            id,
            isInputRequired,
            inputClasses,
            name,
            type,
            placeholder = undefined,
            readOnly = false,
            value = '',
        },
        label: { labelText, labelClasses, ariaLabel },
        legend: { isLegendRequired, helperClasses },
        actions: { handleFieldChange },
    } = props;

    const [ssn, setSsn] = useState(() => getMaskedValue(value));
    const [ssnUndo, setUndoSsn] = useState(() => _maskToDash(value));

    function getMaskedValue(raw) {
        const digitsOnly = raw.replace(/\D/g, '');
        const len = digitsOnly.length;

        if (len === 0) return '';
        if (len <= 2) return '*'.repeat(len);
        if (len <= 3) return '*'.repeat(len);
        if (len <= 5) return `***-${'*'.repeat(len - 3)}`;
        return `***-**-${digitsOnly.slice(5, 9)}`;
    }

    const _onInputChange = event => {
        if (readOnly) return;

        const { value: inputValue } = event.target;
        const string = _maskToDash(inputValue);
        handleFieldChange({ target: { name: name ?? 'ssn', value: string } });
        setSsn(string);
        setUndoSsn(string);
    };

    function _maskToDash(value) {
        let string = value.replace(/-/g, '');
        const match = /^([0-9]{3})([0-9]{2})([0-9]{4})$/.exec(string);
        if (match) {
            match.shift();
            string = match.join('-');
        }
        return string.replace(/[^\d-]/g, '');
    }

    const _maskToAsterisk = () => {
        if (readOnly) return;
        setSsn(getMaskedValue(ssn));
    };

    const _reveal = () => {
        if (readOnly) return;
        setSsn(ssnUndo);
    };

    return (
        <Fragment>
            <div className={`grid-row gi-ssn ${helperClasses && helperClasses.join(' ')}`}>
                <label
                    htmlFor={id}
                    className={`gi-ssn__label ${labelClasses && labelClasses.join(' ')}`}
                    aria-label={ariaLabel}
                >
                    <span className={`required-${isLegendRequired}`}>
                        <FormattedMessage id={labelText} />
                    </span>
                </label>
                <input
                    id={id}
                    name={name}
                    type={type}
                    value={ssn}
                    className={`gi-ssn__input ${inputClasses && inputClasses.join(' ')}`}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    onChange={_onInputChange}
                    maxLength="9"
                    onBlur={_maskToAsterisk}
                    onFocus={_reveal}
                />
            </div>
        </Fragment>
    );
};

export default SSN;
